angular
  .module 'filters'
  .filter 'withoutFraction', ->
    (value = '') ->
      value.toString().split('.')[0]
